<script setup>
const selected = ref('weather')
const isShowGolfLegend = defineModel('isShowGolfLegend', { type: Boolean })
const weatherList = [
  {
    title: 'ゴルフコンディション指数',
    content: [
      {
        name: '最高',
        text: '風も弱くプレーをするには最高のコンディションです。ナイスショット！の声も心地よく響き渡りそうです。',
        rank: '4'
      },
      {
        name: '普通',
        text: 'プレーをするには問題の無い天気です。グッドショットも期待できます。',
        rank: '3'
      },
      {
        name: '今ひとつ',
        text: 'プレーをするには今ひとつな天気です。雨風が強まる時は無理は禁物です。',
        rank: '2'
      },
      {
        name: '不向き',
        text: 'ゴルフを楽しむには過酷な天気です。無理せず日にちを改めてもいいかもしれません。',
        rank: '1'
      }
    ]
  },
  {
    title: '雷リスク指数',
    content: [
      {
        name: '低い',
        text: '雷の心配はほぼありません。',
        rank: '0'
      },
      {
        name: 'やや高い',
        text: '雷が発生する可能性があります。空の変化に注意を。',
        rank: '1'
      },
      {
        name: '高い',
        text: '雷の発生に注意しながらプレーしてください。',
        rank: '2'
      },
      {
        name: '非常に高い',
        text: '雷が発生する危険性が非常に高いです。プレーは中止しましょう。',
        rank: '3'
      }
    ]
  }
]
const clothesList = [
  {
    title: '服装指数',
    content: [
      {
        name: 'ノースリーブ',
        text: 'ノースリーブなど一番涼しい服装がおすすめです。',
        rank: '11'
      },
      {
        name: '半袖（薄手）',
        text: '半袖でも薄手のものを選ぶと良さそうです。',
        rank: '10'
      },
      {
        name: '半袖（厚手）',
        text: 'ポロシャツなど厚手の半袖がおすすめです。',
        rank: '9'
      },
      {
        name: '長袖',
        text: '長袖シャツ一枚でちょうど良さそうです。',
        rank: '8'
      },
      {
        name: 'ベスト',
        text: '長袖シャツにベスト合わせるなど、ワンランク暖かい服装がおすすめです。',
        rank: '7'
      },
      {
        name: '厚手トップス１枚',
        text: '保温性の高い厚手のトップスが良さそうです。',
        rank: '6'
      },
      {
        name: '長袖＋厚手トップス',
        text: '長袖シャツに厚手のトップスを重ねるか、プレー時以外はジャケットなど暖かな上着があると安心です。',
        rank: '5'
      },
      {
        name: 'ダウンベスト',
        text: '厚手のトップスにダウンベストを合わせるなど、保温性の高い服装がおすすめです。',
        rank: '4'
      },
      {
        name: 'ジャケット',
        text: '風を通しにくく保温性も高いようなジャケットが必要です。ネックウォーマーなど首元を温めるアイテムがあると良さそうです。',
        rank: '3'
      },
      {
        name: 'ダウンコート',
        text: 'ダウンコートなど最上級の防寒が必須です。',
        rank: '2'
      }
    ]
  }
]
</script>

<template>
  <div
    class="golfLegend"
    @click="isShowGolfLegend = !isShowGolfLegend"
  >
    <button
      class="legend__close"
      @click="isShowGolfLegend = !isShowGolfLegend"
    />
    <div
      class="card"
      @click.stop
    >
      <div class="tab">
        <div class="tab__inner">
          <button
            :data-select="selected==='weather'"
            @click="selected = 'weather'"
          >
            <span>気象</span>
          </button>
          <button
            :data-select="selected==='clothes'"
            @click="selected = 'clothes'"
          >
            <span>服装</span>
          </button>
        </div>
      </div>
      <template v-if="selected==='weather'">
        <div
          v-for="(item, index1) in weatherList"
          :key="index1"
          class="legend"
        >
          <template v-if="item.title === 'ゴルフコンディション指数'">
            <p class="title">
              {{ item.title }}
            </p>
            <ul class="content">
              <li
                v-for="(item2, index2) in item.content"
                :key="index2"
                class="list"
              >
                <figure class="golf-icon">
                  <img
                    :src="`https://gvs.weathernews.jp/golf/image/golf_status/icon_status_${item2.rank}.svg`"
                    alt=""
                    loading="lazy"
                  >
                </figure>
                <div class="textarea">
                  <p class="name">
                    {{ item2.name }}
                  </p>
                  <p
                    v-if="item2.text"
                    class="text"
                  >
                    {{ item2.text }}
                  </p>
                </div>
              </li>
            </ul>
          </template>
          <template v-if="item.title === '雷リスク指数'">
            <p class="title">
              {{ item.title }}
            </p>
            <ul class="content">
              <li
                v-for="(item2, index2) in item.content"
                :key="index2"
                class="list"
              >
                <figure class="thunder-icon">
                  <img
                    v-if="item2.rank!=='0'"
                    :src="`https://gvs.weathernews.jp/golf/image/thunder/icon_status_thunder_${item2.rank}.svg`"
                    alt=""
                    loading="lazy"
                  >
                </figure>
                <div class="textarea">
                  <p class="name">
                    {{ item2.name }}
                  </p>
                  <p
                    v-if="item2.text"
                    class="text"
                  >
                    {{ item2.text }}
                  </p>
                </div>
              </li>
            </ul>
          </template>
        </div>
      </template>
      <template v-if="selected==='clothes'">
        <div
          v-for="(item, index1) in clothesList"
          :key="index1"
          class="legend"
        >
          <p class="title">
            {{ item.title }}
          </p>
          <ul class="content">
            <li
              v-for="(item2, index2) in item.content"
              :key="index2"
              class="list"
            >
              <figure class="clothe-icon">
                <img
                  :src="`https://gvs.weathernews.jp/golf/image/clothes/c-rank-${item2.rank}.svg`"
                  alt=""
                  loading="lazy"
                >
              </figure>
              <div class="textarea">
                <p class="name">
                  {{ item2.name }}
                </p>
                <p
                  v-if="item2.text"
                  class="text"
                >
                  {{ item2.text }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.golfLegend {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100svh;
  background-color: rgb(0 0 0 / .33);
  z-index: 100;
  .legend__close {
    position: absolute;
    width: 25px;
    height: 25px;
    top: max(calc(10% - 35px), calc(50% - 320px));
    right: max(10%, calc(50% - 300px));
    cursor: pointer;
    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 35px;
      height: 4px;
      border-radius: 100vmax;
      background-color: #fff;
      content: '';
    }
    &::before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
  .card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 80%;
    max-width: 600px;
    max-height: 570px;
    padding: 25px 15px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 100vmax;
    }
    &::-webkit-scrollbar-thumb {
      background: #3569c0;
      border-radius: 100vmax;
    }
  }
  .tab {
    display: flex;
    justify-content: center;
    width: 100%;
    .tab__inner {
      display: flex;
      max-width: 300px;
      width: 100%;
      gap: 10px;
      justify-content: space-between;
      padding-inline: 10px;
      background-color: #E3EDED;
      border-radius: 5px;
      &:is(#detail *) {
        margin-inline: 10px;
      }
      button {
        position: relative;
        flex: 1;
        &::before {
          position: absolute;
          top: -1px;
          left: 0;
          width: 100%;
          height: 26px;
          content: "";
          background-color: #3569c0;
          border-radius: 2px;
          box-shadow: 0 2px 2px 0 #dde5e9;
          opacity: 0;
        }
        &[data-select="true"] {
          pointer-events: none;
        }
        &[data-select="true"]::before {
          opacity: 1;
        }
        &:not(:last-child) {
          &::after {
            position: absolute;
            top: 50%;
            left: calc(100% + 5px);
            width: 1px;
            height: 9px;
            content: "";
            background-color: #808080;
            transform: translateY(-50%);
          }
        }
        span {
          display: block;
          position: relative;
          font-size: 13px;
          line-height: 24px;
          color: #3569c0;
          text-align: center;
          text-decoration: underline;
          &:is([data-select="true"] span) {
            font-weight: 600;
            color: #fff;
            text-decoration: none;
          }
        }
      }
      @media (any-hover: hover) {
        button {
          span {
            transition: scale .3s ease-in-out;
          }
          &:hover {
            span {
              scale: 1.05;
              font-weight: 600;
            }
            .note {
              scale: 0.95;
            }
          }
        }
      }
    }
  }
  .legend {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 10px;
    border-bottom: solid 1px #808080;
    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 5px;
      .list {
        display: flex;
        align-items: center;
        gap: 10px;
        figure {
          &.golf-icon {
            width: 36px;
            aspect-ratio: 1 / 1;
            img {
              width: 100%;
            }
          }
          &.thunder-icon {
            width: 36px;
            aspect-ratio: 3 / 2;
            img {
              width: 100%;
            }
          }
          &.clothe-icon {
            width: 36px;
            aspect-ratio: 50 / 43;
            img {
              width: 100%;
            }
          }
        }
        .textarea {
          display: flex;
          flex-direction: column;
          gap: 5px;
          flex: 1;
        }
        .name {
          font-size: 14px;
          font-weight: 600;
          line-height: 1.2em;
        }
        .text {
          font-size: 12px;
          line-height: 1.2em;
        }
      }
    }
  }
}
</style>
